//import { getRealPathname } from "./getRealPathname";

export const getPageSource = () => {
    const queryString = location.search;
    const params = new URLSearchParams(queryString);

    const source = params.get('utm_campaign');
    if (source) {
        return source;
    }
    const pathnameA = location.pathname || '';
    // blog 分类
    if (pathnameA.includes('/blog')) {
        return 'ecoflow-blog';
    }
    return '';
};
